import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ImportYearToDate } from "../../components/ImportYearToDate";

export const ImportYearToDatePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ImportYearToDate />}
    />
  );
};
